import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExceptionState, Vehicle } from '../../services/http/vehicles/vehicles.interface';
import { VehicleTypeTagComponent } from '../vehicle-type-tag/vehicle-type-tag.component';

@Component({
  selector: 'app-vehicle-iccon-resume',
  standalone: true,
  imports: [CommonModule, VehicleTypeTagComponent],
  templateUrl: './vehicle-iccon-resume.component.html',
  styleUrl: './vehicle-iccon-resume.component.scss'
})
export class VehicleIcconResumeComponent {
  iconClass = "bi-car-front-fill";
  ExceptionState = ExceptionState;

  @Input() vehicle: Vehicle | undefined;
  @Input() showPending = false;
}
